import { TextSpinner } from 'ui'
import Card from '../../common/Card'
import classNames from 'classnames'

type Props<T> = {
   items: T[]
   isLoading: boolean
   emptyText: string
   renderItem: (item: T, index: number) => React.ReactNode
   renderFooter?: () => React.ReactNode
   title?: string
}

function HistoryList<T>({ items, isLoading, emptyText, renderItem, renderFooter, title = 'History' }: Props<T>) {
   return (
      <Card>
         <Card.Title>{title}</Card.Title>

         {isLoading ? (
            Array.from({ length: 4 }, (_, i) => (
               <div className="p-4" key={i}>
                  <div className="flex gap-2">
                     <div className="w-full">
                        <TextSpinner className="mb-2" />
                        <TextSpinner />
                     </div>
                  </div>
               </div>
            ))
         ) : items.length === 0 ? (
            <div className="p-4 text-center text-neutral-400">{emptyText}</div>
         ) : (
            <>
               <div className={classNames('overflow-auto max-h-[714px]')}>
                  {items.map((item, index) => (
                     <div key={index} className="p-4">
                        {renderItem(item, index)}
                     </div>
                  ))}
               </div>
               {renderFooter && renderFooter()}
            </>
         )}
      </Card>
   )
}

export default HistoryList
